<oui-accordion
  [id]="anchorId()"
  class="investor-viewer-accordion"
  [expanded]="expanded()">
  <oui-accordion-header class="investor-viewer-accordion-header">
    <oui-accordion-title>
      @if (level() === 'title') {
        <h4><ng-container *ngTemplateOutlet="titleFragment"></ng-container></h4>
      } @else {
        <h5><ng-container *ngTemplateOutlet="titleFragment"></ng-container></h5>
      }
    </oui-accordion-title>
    <oui-accordion-description>
      <ng-content select="[accordion-description]"></ng-content>
    </oui-accordion-description>
    <oui-accordion-actions>
      <ng-content select="[accordion-actions]"></ng-content>
    </oui-accordion-actions>
  </oui-accordion-header>

  <div class="investor-viewer-accordion-content">
    <ng-content></ng-content>
  </div>
</oui-accordion>

<ng-template #titleFragment>
  {{ accordionTitle() }}
  @if (loading(); as loading) {
    (chargement...)
  }
  @if (itemsCount() !== undefined) {
    ({{ itemsCount() }})
  }
</ng-template>
